"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _index = _interopRequireDefault(require("./index.vue"));
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    popup: _index.default
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: ''
    },
    title: {
      type: [String, Number, Boolean],
      default: '图片'
    },
    padding: {
      type: [String, Number, Boolean],
      default: false
    }
  },
  data: function data() {
    return {
      paddingStyle: '28px',
      top: '100%'
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    url: {
      get: function get() {
        return this.value || false;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var height, width, contrast;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.padding) {
              this.paddingStyle = this.padding;
            } else {
              height = this.$refs.picture.offsetHeight;
              width = this.$refs.picture.offsetWidth;
              contrast = width;
              if (height > width) {
                contrast = height;
                this.top = width / height * 100 + '%';
              } else {
                this.top = height / width * 100 + '%';
              }
              if (contrast > 100) {
                this.paddingStyle = '28px';
              } else if (contrast > 60) {
                this.paddingStyle = '10px 0 0 0';
              } else {
                this.paddingStyle = '16px';
              }
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    handleConfirm: function handleConfirm(value) {
      this.url = value;
    }
  }
};
exports.default = _default;